

export const FETCH_COMMERCIAL_LICENSE_MAPPINGS_REQUEST = 'commercialLicenseMappings/FETCH_COMMERCIAL_LICENSE_MAPPINGS_REQUEST';
export const FETCH_COMMERCIAL_LICENSE_MAPPINGS_SUCCESS = 'commercialLicenseMappings/FETCH_COMMERCIAL_LICENSE_MAPPINGS_SUCCESS';
export const FETCH_COMMERCIAL_LICENSE_MAPPINGS_FAILURE = 'commercialLicenseMappings/FETCH_COMMERCIAL_LICENSE_MAPPINGS_FAILURE';


export const FETCH_COMMERCIAL_LICENSE_MAPPING_REQUEST = 'commercialLicenseMappings/FETCH_COMMERCIAL_LICENSE_MAPPING_REQUEST';
export const FETCH_COMMERCIAL_LICENSE_MAPPING_SUCCESS = 'commercialLicenseMappings/FETCH_COMMERCIAL_LICENSE_MAPPING_SUCCESS';
export const FETCH_COMMERCIAL_LICENSE_MAPPING_FAILURE = 'commercialLicenseMappings/FETCH_COMMERCIAL_LICENSE_MAPPING_FAILURE';


export const DELETE_COMMERCIAL_LICENSE_MAPPING_REQUEST = 'commercialLicenseMappings/DELETE_COMMERCIAL_LICENSE_MAPPING_REQUEST';
export const DELETE_COMMERCIAL_LICENSE_MAPPING_SUCCESS = 'commercialLicenseMappings/DELETE_COMMERCIAL_LICENSE_MAPPING_SUCCESS';
export const DELETE_COMMERCIAL_LICENSE_MAPPING_FAILURE = 'commercialLicenseMappings/DELETE_COMMERCIAL_LICENSE_MAPPING_FAILURE';


export const CREATE_COMMERCIAL_LICENSE_MAPPING_REQUEST = 'commercialLicenseMappings/CREATE_COMMERCIAL_LICENSE_MAPPING_REQUEST';
export const CREATE_COMMERCIAL_LICENSE_MAPPING_SUCCESS = 'commercialLicenseMappings/CREATE_COMMERCIAL_LICENSE_MAPPING_SUCCESS';
export const CREATE_COMMERCIAL_LICENSE_MAPPING_FAILURE = 'commercialLicenseMappings/CREATE_COMMERCIAL_LICENSE_MAPPING_FAILURE';


export const UPDATE_COMMERCIAL_LICENSE_MAPPING_REQUEST = 'commercialLicenseMappings/UPDATE_COMMERCIAL_LICENSE_MAPPING_REQUEST';
export const UPDATE_COMMERCIAL_LICENSE_MAPPING_SUCCESS = 'commercialLicenseMappings/UPDATE_COMMERCIAL_LICENSE_MAPPING_SUCCESS';
export const UPDATE_COMMERCIAL_LICENSE_MAPPING_FAILURE = 'commercialLicenseMappings/UPDATE_COMMERCIAL_LICENSE_MAPPING_FAILURE';

export const ORDER_COMMERCIAL_LICENSE_MAPPINGS_REQUEST = 'commercialLicenseMappings/ORDER_COMMERCIAL_LICENSE_MAPPINGS_REQUEST';
export const ORDER_COMMERCIAL_LICENSE_MAPPINGS_SUCCESS = 'commercialLicenseMappings/ORDER_COMMERCIAL_LICENSE_MAPPINGS_SUCCESS';
export const ORDER_COMMERCIAL_LICENSE_MAPPINGS_FAILURE = 'commercialLicenseMappings/ORDER_COMMERCIAL_LICENSE_MAPPINGS_FAILURE';


export const UPDATE_FIELD = 'commercialLicenseMappings/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'commercialLicenseMappings/SET_DEFAULT_DATA';
